import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Carousel as Carousel$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockCarousel = function BlockCarousel(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var contents = innerBlocks.map(function (innerBlock) {
    return /*#__PURE__*/React.createElement(Carousel$1.Item, {
      key: innerBlock.attrs.id,
      id: innerBlock.attrs.id,
      justifyContent: innerBlock.attrs.justifyContent,
      alignItems: innerBlock.attrs.alignItems,
      tab: innerBlock.attrs.heading
    }, generateBlockList({
      blocks: innerBlock.innerBlocks
    }));
  });
  return /*#__PURE__*/React.createElement(Carousel$1, _extends({}, attrs, {
    key: index
  }), contents);
};
BlockCarousel.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})),
  attrs: PropTypes.shape({
    id: PropTypes.string,
    showDots: PropTypes.bool,
    showTabs: PropTypes.bool,
    showArrows: PropTypes.bool
  })
} : {};
var Carousel = BlockCarousel;

export { Carousel as default };
